import React, { useMemo, useState } from "react";
import { Table, Button, Flex, Tooltip, Modal, Space, Empty } from "antd";
import {
  EditOutlined,
  SearchOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import '../SupplierAdministrationTable/SupplierAdministrationTable.css'
import '../../../../api/axiosInstance'
import {axiosInstance} from "../../../../api/axiosInstance";
import { toast } from "react-toastify";

const SupplierAdministrationTable = ({
  tableData,
  pageNumber,
  pageSize,
  totalRows,
  onFilterChanged,
  setMode,
  setSupplierAdministrationModalOpened,
  setRowData,
  refreshData,
}) => {
  const [arrow, setArrow] = useState("Show");

  const [modal, contextHolder] = Modal.useModal();

  const confirm = (id) => {
    modal.confirm({
      title: "Potvrda",
      icon: <ExclamationCircleOutlined />,
      content: "Jeste li sigurni da želite obrisati dobavljača?",
      okText: "Da",
      cancelText: "Ne",
      centered: true,
      onOk: () => {
        axiosInstance.delete(`/api/v1/suppliers/${id}`)
        .then(res => {
          toast.success("Dobavljač je uspješno obrisan!");
          refreshData();
        }).catch(ex => {
          toast.error(`${ex.response.data.errorMessage}`);
        })
      },
    });
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }

    if (arrow === "Show") {
      return true;
    }

    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const tableColumns = () => {
    return [
      {
        title: "Naziv",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Kategorija",
        dataIndex: ["expenseType", "name"],
        key: "expenseType",
      },
      {
        title: "Ulica",
        dataIndex: ["streetName"],
        key: "streetName",
        render: (value) => <div>{value ? value : "-"}</div>
      },
      {
        title: "Kućni broj",
        dataIndex: ["houseNumber"],
        key: "houseNumber",
        render: (value) => <div>{value ? value : "-"}</div>
      },
      {
        title: "Poštanski broj",
        dataIndex: ["postCode"],
        key: "postCode",
        render: (value) => <div>{value ? value : "-"}</div>
      },
      {
        title: "Grad",
        dataIndex: ["city"],
        key: "city",
        render: (value) => <div>{value ? value : "-"}</div>
      },
      {
        title: "OIB",
        dataIndex: ["oib"],
        key: "oib",
        render: (value) => <div>{value ? value : "-"}</div>
      },
      {
        title: "IBAN",
        dataIndex: ["iban"],
        key: "iban",
        render: (value) => <div>{value ? value : "-"}</div>
      },
      {
        title: "",
        key: "operation",
        //fixed: "right",
        width: "150px",
        render: (text, record, index) => (
          <Flex vertical={false} gap={"4px"}>
            <Tooltip
              placement="top"
              title={<span>Pregled</span>}
              arrow={mergedArrow}
            >
              <Button
                type="text"
                size="large"
                icon={<SearchOutlined />}
                onClick={() => {
                  setMode("preview");
                  setRowData(record);
                  setSupplierAdministrationModalOpened(true);
                }}
              />
            </Tooltip>
            <Tooltip
              placement="top"
              title={<span>Uređivanje</span>}
              arrow={mergedArrow}
            >
              <Button
                type="text"
                size="large"
                icon={<EditOutlined />}
                onClick={() => {
                  setMode("edit");
                  setSupplierAdministrationModalOpened(true);
                  setRowData(record);
                }}
              />
            </Tooltip>
            <Tooltip
              placement="top"
              title={<span>Brisanje</span>}
              arrow={mergedArrow}
            >
              <Space>
                <Button
                  type="text"
                  size="large"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => confirm(record.id)}
                />
              </Space>
            </Tooltip>
          </Flex>
        ),
      },
    ];
  };

  return (
    <>
      <Table
        columns={tableColumns()}
        dataSource={tableData}
        onChange={(pagination, filters, sorter) =>
          onFilterChanged(pagination, filters, sorter)
        }
        style={{ marginTop: "32px"}}
        pageNumber={pageNumber}
        pageSize={pageSize}
        pagination={{ 
          defaultPageSize: 10, 
          showSizeChanger: true, 
          pageSizeOptions: ['10', '20', '30'], 
          total: totalRows, 
          showTotal: (total, range) =>  `Ukupan broj rezultata: ${totalRows}`
        }} 
        bordered
        scroll={{ x: 700 }}
        locale={{ emptyText:  <Empty description="Nije pronađen nit jedan dobavljač."/> }}
      />
      {contextHolder}
    </>
  );
};
export default SupplierAdministrationTable;
